import React from 'react';
import "./table-info.scss";
import SlideOutSidebar from '../../../../ui-components/slide-out-sidebar/slideOutSidebar';

interface PopupSection {
  title?: string;
  label?: string;
  desc?: string;
}

interface SidePopupProps {
  show: boolean;
  onClose: () => void;
  popUpHeader: string;
  title: string;
  description: string;
  sections: PopupSection[][];
}

const SidePopup: React.FC<SidePopupProps> = ({ show, onClose, popUpHeader, title, description, sections }) => {

  return (
    <SlideOutSidebar
      header={popUpHeader}
      onClose={onClose}
      size="extrasmall"
      show={show}
    >
      <div className="xgs-image-table-info__side-panel-body">
        <div className="xgs-image-table-info__side-panel-title-block">
          <div className="xgs-image-table-info__side-panel-title">{title}</div>
          <div className="xgs-image-table-info__side-panel-description">{description}</div>
        </div>

        {sections.map((section, i) => (
          <div key={i} className="xgs-image-table-info__side-panel-section">
            {section.map((item, j) => (
              <div key={j} className="xgs-image-table-info__side-panel-item">
                {item.title && <div className="xgs-image-table-info__item-title">{item.title}</div>}
                {item.label && <div className="xgs-image-table-info__item-label">{item.label}</div>}
                {item.desc && <div className="xgs-image-table-info__item-desc">{item.desc}</div>}
              </div>
            ))}
          </div>
        ))}
      </div>
    </SlideOutSidebar>
  );
};

export default SidePopup;